import { ExternalLink as ExternalLinkIcon, Users } from "lucide-react";

import { ExternalLink } from "components/ExternalLink";

import classes from "./emptyState.module.css";

export const WaitingForCustomers = () => {
  return (
    <div className={classes.container}>
      <div className={classes.card}>
        <div className={classes.cardHeader}>
          <h2 className={`${classes.cardTitle} text-doto`}>Waiting for first customer</h2>
          <p className={classes.cardDescription}>
            Your integrations are set up. Customers will appear here once they
            connect.
          </p>
        </div>
        <div className={classes.cardContent}>
          <div className={classes.waitingContent}>
            <Users size={48} className={classes.waitingIcon} />
            <p className={classes.waitingText}>
              If you want to embed the UI components for your customers to connect and install, see the{" "}
              <ExternalLink
                url="https://docs.ampersand.ai/quickstart#embed-ui-components"
                text="pre-built UI components"
              />{" "}
              section of the quickstart guide. 
              </p>

              <p className={classes.waitingText}>
              Otherwise, you can build your own UI with our {" "}
              <ExternalLink
                url="https://docs.ampersand.ai/headless"
                text="headless library"
              />
            </p>
          </div>
          <div className={classes.footer}>
            <a
              href="https://docs.ampersand.ai"
              target="_blank"
              rel="noopener noreferrer"
              className={classes.docsLink}
            >
              <ExternalLinkIcon size={16} />
              View documentation
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
